import { ActionTree } from 'vuex'
import { PartyRoomState, PartyRoom } from '@/types/PartyRoom'
import RootState from '@/types/RootState'
import APIClient from '@/API/APIClient'
import firebase from 'firebase'
import SongRequest from '@/types/SongRequest'

export const actions: ActionTree<PartyRoomState, RootState> = {
  async createRoom ({ commit, rootState }, name: string): Promise<void> {
    if (!(rootState.user && rootState.user.user && rootState.user.user.userID)) throw new Error('No user was provided when creating a room')
    const createdRoom = await APIClient.PartyRoom.createRoom(name, rootState.user.user.userID)
    commit('setPartyRoom', createdRoom)
  },
  async fetchRoom ({ commit }, partyID: string): Promise<void> {
    firebase.firestore().collection('partyrooms').doc(String(partyID)).onSnapshot((room) => {
      if (room.exists) {
        commit('setPartyRoom', room.data() as PartyRoom)
      } else {
        throw new Error('Unable to find a room for the provided partyID')
      }
    }, error => {
      console.log(error)
    })
  },
  async addUserToParty ({ commit, state, rootState }): Promise<void> {
    if (!(state.partyRoom && rootState.user && rootState.user.user)) throw new Error('We were unable to add the user to the Party room')
    await APIClient.PartyRoom.addUserToRoom(state.partyRoom.partyID, rootState.user.user)
  },
  async mountQueue ({ commit }, partyID: string): Promise<any> {
    firebase.firestore().collection('partyrooms').doc(String(partyID))
      .collection('queue')
      .where('played', '==', false)
      .orderBy('upVotes', 'desc')
      .orderBy('requested')
      .onSnapshot((queueSnap) => {
        commit('clearSongs')
        queueSnap.forEach((song) => {
          const songRequest: SongRequest = song.data() as SongRequest
          songRequest.requestId = song.id
          commit('addSong', songRequest)
        })
      }, (error) => {
        console.log(error)
      })
  },
  async mountVotesForNext ({ commit }, partyID: string): Promise<void> {
    firebase.firestore().collection('partyrooms').doc(String(partyID))
      .collection('votesForNext')
      .onSnapshot((voteSnap) => {
        commit('clearVotesForNext')
        voteSnap.forEach((vote) => {
          commit('addVoteForNext', vote.data().userID as string)
        })
      }, error => console.log(error))
  }
}
